module.exports = __webpack_public_path__ + "Isabel.jpg?e351962c5ae4252cbaf4f48418fa198d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/Isabel.jpg
// module id = 174
// module chunks = 0